import { cn } from '@moreharvest/component-library';

const sectionWrapperWideClasses =
    'flex flex-col gap-y-4 w-full px-4 lg:px-0 lg:max-w-[1120px] mx-auto lg:gap-y-12';
const sectionWrapperNarrowClasses =
    'flex flex-col gap-y-4 w-full px-4 lg:w-[544px] mx-auto lg:gap-y-12 py-0';
const sectionWrapperNarrowBoxedClasses = cn(
    'flex flex-col gap-y-4 w-full px-4 lg:w-[544px] mx-auto lg:gap-y-12',
    'overflow-x-clip lg:m-auto lg:inline-flex',
    'lg:bg-neutral-50 dark:lg:bg-neutral-50-dark',
    'lg:py-12 lg:px-8 lg:rounded-2xl',
    'lg:border-neutral-200 dark:lg:border-neutral-200-dark lg:border-1'
);

export const SectionWrapperWide = ({
    className,
    ...props
}: React.HTMLAttributes<HTMLElement>) => (
    <section className={cn(sectionWrapperWideClasses, className)} {...props} />
);

export const SectionWrapperNarrow = ({
    className,
    ...props
}: React.HTMLAttributes<HTMLElement>) => (
    <section
        className={cn(sectionWrapperNarrowClasses, className)}
        {...props}
    />
);

export const SectionWrapperNarrowBoxed = ({
    className,
    ...props
}: React.HTMLAttributes<HTMLElement>) => (
    <section
        className={cn(sectionWrapperNarrowBoxedClasses, className)}
        {...props}
    />
);
